import { render, staticRenderFns } from "./handlePageClassDialog.vue?vue&type=template&id=4551aea3&scoped=true"
import script from "./handlePageClassDialog.vue?vue&type=script&lang=js"
export * from "./handlePageClassDialog.vue?vue&type=script&lang=js"
import style0 from "./handlePageClassDialog.vue?vue&type=style&index=0&id=4551aea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551aea3",
  null
  
)

export default component.exports